import { createFileRoute } from '@tanstack/react-router';

import { scratchpadSearchSchema } from '@apps/web/features/admin_agent_scratchpad/model/search_params';
import { ScratchpadIndexPage } from '@apps/web/features/admin_agent_scratchpad/ui/index_page';
import { ScratchpadNotesFrame } from '@apps/web/features/admin_agent_scratchpad/ui/notes_frame';

export const Route = createFileRoute('/_app/admin/agent/scratchpad/')({
    component: ScratchpadIndexRoute,
    validateSearch: scratchpadSearchSchema,
    head: () => ({
        meta: [{ title: 'Notes | Internal Admin Agent' }],
    }),
});

function ScratchpadIndexRoute() {
    const search = Route.useSearch();
    return (
        <ScratchpadNotesFrame>
            <ScratchpadIndexPage search={search} />
        </ScratchpadNotesFrame>
    );
}
